import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { inject, observer } from 'mobx-react'
import { Dropdown, Menu, message, Modal, Tooltip } from 'antd'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentHeadingWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
  HeadingTitleWrapper,
} from '../../layouts/ConnectedDocumentDetailLayout/ConnectedDocumentDetailLayoutStyled'
import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  MoreOutlined,
} from '@ant-design/icons'
import { useMediaQuery } from 'react-responsive'
// PDF Viewer
import PDFViewer from '../../components/PDFViewer'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import TrucWrapper from '../../components/TrucWrapper'
import { EmptyText, TitleContentBox } from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import utils from '../../utils'
import { blue } from '../../color'
import moment from 'moment'
import { ACL_ACTION_TYPE, DATE_FORMAT_DEFAULT } from '../../constants'
import ConnectedDocumentIncomingDocHistoryBlock from '../../components/ConnectedDocumentIncomingDocHistoryBlock'
import PopoverWatchTime from '../../components/PopoverWatchTime'

const { confirm } = Modal

const ConnectedDocumentOutgoingDocDetailPage = props => {
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    match,
    commonStore,
    connectedDocumentStore,
    loadingAnimationStore,
    history,
    aclStore,
  } = props

  const { documentId } = match.params
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore
  const { selectedOutgoingDocument, actionLogList } = connectedDocumentStore

  const {
    attachments,
    code,
    createdAt,
    subject,
    userFrom,
    listUserTo,
    view_logs,
  } = selectedOutgoingDocument

  const renderInfoText = string => {
    if (string) {
      if (string.length <= 20) return string
      return (
        <Tooltip title={string}>
          {string.substring(0, 20).concat('...')}
        </Tooltip>
      )
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        const response = await connectedDocumentStore.getOutgoingDocumentById(
          documentId
        )
        await connectedDocumentStore.getLogDocument(documentId, 'DOC_OUTGOING')
        const filePDFList = response.data.attachments
          ? response.data.attachments.filter(x =>
              x.name.toLocaleLowerCase().includes('.pdf')
            )
          : []
        if (filePDFList.length === 0) {
          loadingAnimationStore.showSpinner(false)
          return
        }
        await connectedDocumentStore.getOutgoingDocumentAttachmentById(
          documentId,
          filePDFList[0].fileId
        )
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      connectedDocumentStore.clearSelectedOutgoingDocument()
      connectedDocumentStore.clearLogDocument()
    }
  }, [documentId])

  const [attachmentForView, setAttachmentForView] = useState()

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachmentFile = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )

  const handleDeleteDoc = () => {
    loadingAnimationStore.showSpinner(true)
    connectedDocumentStore
      .deleteOutgoingDocumentByID(documentId)
      .then(() => {
        loadingAnimationStore.showSpinner(false)
        history.goBack()
        message.success('Xóa văn bản thành công!')
      })
      .catch(error => {
        loadingAnimationStore.showSpinner(false)
        message.error(error.vi)
      })
  }

  const showConfirm = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Đồng ý',
      onOk() {
        handleDeleteDoc()
      },
    })
  }

  const menuHandleDoc = (
    <Menu>
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.edit__LIEN_THONG_OUTGOING
      ) && (
        <Menu.Item
          onClick={() =>
            history.push(`/connected-document/outgoing-document/${documentId}`)
          }
          style={{ color: blue }}
          icon={<EditOutlined />}>
          Chỉnh sửa văn bản
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.delete__LIEN_THONG_OUTGOING
      ) && (
        <Menu.Item danger onClick={showConfirm} icon={<DeleteOutlined />}>
          Xóa văn bản
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <TrucWrapper>
      <DashboardLayout>
        <Helmet>
          <title>{`${subject} | Can Tho Port Quản lý VB nội bộ`}</title>
        </Helmet>
        <DocumentHeadingWrapper>
          <HeadingTitleWrapper>
            <PageTitle
              location={props.location}
              title={subject}
              showTitle={true}
              color={commonStore.appTheme.solidColor}
            />
          </HeadingTitleWrapper>
          <HeadingButtonWrapper>
            <Dropdown overlay={menuHandleDoc} trigger={'click'}>
              <span className={'btn-style'}>
                <MoreOutlined />
              </span>
            </Dropdown>
          </HeadingButtonWrapper>
        </DocumentHeadingWrapper>
        <DocumentContentWrapper>
          <BlockLeft>{renderAttachmentFile}</BlockLeft>
          <BlockRight>
            <ContentBlockWrapper>
              <TitleContentBox>Thông tin chung</TitleContentBox>
              <DocumentInfoList>
                <dt>Sổ văn bản</dt>
                <dd>{code && renderInfoText(code)}</dd>
                <dt>Nơi ban hành</dt>
                <dd>{userFrom && userFrom}</dd>
                <dt>Nơi nhận</dt>
                <dd style={{ marginBottom: 8 }}>
                  {listUserTo && listUserTo.length > 0 ? (
                    <PopoverWatchTime
                      userList={listUserTo}
                      title={'Nơi nhận'}
                    />
                  ) : (
                    <p>Không có</p>
                  )}
                </dd>
                <dt>Ngày gửi</dt>
                <dd>
                  {createdAt && (
                    <>
                      <CalendarOutlined
                        style={{ color: blue, marginRight: 4 }}
                      />
                      <span>
                        {moment(createdAt).format(DATE_FORMAT_DEFAULT)}
                      </span>
                    </>
                  )}
                </dd>
                <dt>Tài liệu đính kèm</dt>
                <dd>
                  <div>
                    {attachments ? (
                      attachments.map(file => (
                        <FileItem
                          key={file.fileId}
                          file_id={file.fileId}
                          file_name={file.name}
                          file_type={utils.getExtensionFile(file.name)}
                        />
                      ))
                    ) : (
                      <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                    )}
                  </div>
                </dd>
                <dt>Đã xem</dt>
                <dd style={{ marginBottom: 8 }}>
                  {view_logs && view_logs.length > 0 ? (
                    <PopoverWatchTime userList={view_logs} title={'Đã xem'} />
                  ) : (
                    <p>Không có</p>
                  )}
                </dd>
              </DocumentInfoList>
            </ContentBlockWrapper>
            {actionLogList.length > 0 && (
              <>
                <div style={{ marginBottom: 15 }} />
                <ContentBlockWrapper>
                  <ConnectedDocumentIncomingDocHistoryBlock
                    history={actionLogList}
                    title={'Lịch sử văn bản đi'}
                  />
                </ContentBlockWrapper>
              </>
            )}
          </BlockRight>
        </DocumentContentWrapper>
      </DashboardLayout>
    </TrucWrapper>
  )
}
ConnectedDocumentOutgoingDocDetailPage.propTypes = {}
export default inject(
  'commonStore',
  'connectedDocumentStore',
  'loadingAnimationStore',
  'aclStore',
)(observer(ConnectedDocumentOutgoingDocDetailPage))
